/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfEvent } from '../models';
// @ts-ignore
import type { BfEventDetail } from '../models';
/**
 * EventQueryApi - axios parameter creator
 */
export const EventQueryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve additional detail for a given `BfEvent` identified by its eKey.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get event detail (eKey)
         * @param {string} eKey 
         * @param {number} [limit] Number of event versions to include in the history (default 16, max 200)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventDetail: async (eKey: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eKey' is not null or undefined
            assertParamExists('eventDetail', 'eKey', eKey)
            const localVarPath = `/v1/event/detail/{e_key}`
                .replace(`{${"e_key"}}`, encodeURIComponent(String(eKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a `BfEvent` by its unique hash
         * @summary Get unique event (eHash)
         * @param {string} eHash 
         * @param {boolean} [simple] Return simple representation
         * @param {boolean} [latest] Return latest version of event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventByHash: async (eHash: string, simple?: boolean, latest?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eHash' is not null or undefined
            assertParamExists('getEventByHash', 'eHash', eHash)
            const localVarPath = `/v1/event/{e_hash}`
                .replace(`{${"e_hash"}}`, encodeURIComponent(String(eHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            if (latest !== undefined) {
                localVarQueryParameter['latest'] = latest;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a set of `BfEvent` by their common eKey
         * @summary Get unique event (eKey)
         * @param {string} eKey 
         * @param {boolean} [simple] Return simple representation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedEventByEKey: async (eKey: string, simple?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eKey' is not null or undefined
            assertParamExists('getRelatedEventByEKey', 'eKey', eKey)
            const localVarPath = `/v1/event/related/{e_key}`
                .replace(`{${"e_key"}}`, encodeURIComponent(String(eKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventQueryApi - functional programming interface
 */
export const EventQueryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventQueryApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve additional detail for a given `BfEvent` identified by its eKey.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get event detail (eKey)
         * @param {string} eKey 
         * @param {number} [limit] Number of event versions to include in the history (default 16, max 200)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventDetail(eKey: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfEventDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventDetail(eKey, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventQueryApi.eventDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a `BfEvent` by its unique hash
         * @summary Get unique event (eHash)
         * @param {string} eHash 
         * @param {boolean} [simple] Return simple representation
         * @param {boolean} [latest] Return latest version of event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventByHash(eHash: string, simple?: boolean, latest?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventByHash(eHash, simple, latest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventQueryApi.getEventByHash']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a set of `BfEvent` by their common eKey
         * @summary Get unique event (eKey)
         * @param {string} eKey 
         * @param {boolean} [simple] Return simple representation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedEventByEKey(eKey: string, simple?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedEventByEKey(eKey, simple, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventQueryApi.getRelatedEventByEKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventQueryApi - factory interface
 */
export const EventQueryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventQueryApiFp(configuration)
    return {
        /**
         * Retrieve additional detail for a given `BfEvent` identified by its eKey.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get event detail (eKey)
         * @param {string} eKey 
         * @param {number} [limit] Number of event versions to include in the history (default 16, max 200)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventDetail(eKey: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<BfEventDetail> {
            return localVarFp.eventDetail(eKey, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a `BfEvent` by its unique hash
         * @summary Get unique event (eHash)
         * @param {string} eHash 
         * @param {boolean} [simple] Return simple representation
         * @param {boolean} [latest] Return latest version of event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventByHash(eHash: string, simple?: boolean, latest?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<BfEvent> {
            return localVarFp.getEventByHash(eHash, simple, latest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a set of `BfEvent` by their common eKey
         * @summary Get unique event (eKey)
         * @param {string} eKey 
         * @param {boolean} [simple] Return simple representation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedEventByEKey(eKey: string, simple?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<BfEvent> {
            return localVarFp.getRelatedEventByEKey(eKey, simple, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventQueryApi - object-oriented interface
 */
export class EventQueryApi extends BaseAPI {
    /**
     * Retrieve additional detail for a given `BfEvent` identified by its eKey.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get event detail (eKey)
     * @param {string} eKey 
     * @param {number} [limit] Number of event versions to include in the history (default 16, max 200)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public eventDetail(eKey: string, limit?: number, options?: RawAxiosRequestConfig) {
        return EventQueryApiFp(this.configuration).eventDetail(eKey, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a `BfEvent` by its unique hash
     * @summary Get unique event (eHash)
     * @param {string} eHash 
     * @param {boolean} [simple] Return simple representation
     * @param {boolean} [latest] Return latest version of event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEventByHash(eHash: string, simple?: boolean, latest?: boolean, options?: RawAxiosRequestConfig) {
        return EventQueryApiFp(this.configuration).getEventByHash(eHash, simple, latest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a set of `BfEvent` by their common eKey
     * @summary Get unique event (eKey)
     * @param {string} eKey 
     * @param {boolean} [simple] Return simple representation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRelatedEventByEKey(eKey: string, simple?: boolean, options?: RawAxiosRequestConfig) {
        return EventQueryApiFp(this.configuration).getRelatedEventByEKey(eKey, simple, options).then((request) => request(this.axios, this.basePath));
    }
}

